import React from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import "./Logout_Confirmation_Modal.css";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { AuthLogOut } from "../../../features/auth/Slice";
import { useDispatch } from "react-redux";
const Logout_Confirmation_Modal = ({
  show,
  onHide,
  modalHeadingText,
  imgSrc,
  btnText,
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const handleLogout = async () => {
    await dispatch(AuthLogOut());
    Cookies.remove("ultimate_analytics_admin_security");
    navigate("/");
  };

  return (
    <Modal
      className="common_modal Logout_Confirmation_Modal"
      centered
      show={show}
      onHide={onHide}
      size="sm"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={onHide}>
            <Common_Back_Btn />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="cerificate_img_holder">
          <div className="btn_holder">
            <Black_Submit_Btn btnText={"Logout"} onClick={handleLogout} />
            <Gray_Btn btnText={"Cancel"} onClick={onHide} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Logout_Confirmation_Modal;
